import React from 'react';
import ReportStatusBadge from './ReportStatusBadge';
import { convertDateTimeTo12Hour, convertTo12HourIfNeeded } from '../../services/TimeFormat24hr';

const ReportTable = ({ columns, rows }) => {
    if (rows.length === 0) {
        return (
            <div className="text-center py-12 text-gray-500">
                <p>No data found for the selected criteria.</p>
            </div>
        );
    }

    return (
        <div className="overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-500">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                    <tr>
                        <th className="px-6 py-3">SN</th>
                        {columns.map(col => (
                            <th key={col.key} scope="col" className="px-6 py-3">{col.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, rowIndex) => (
                        <tr key={rowIndex} className="bg-white border-b hover:bg-gray-50">
                            {/* SN Number */}
                            <td className="px-6 py-4 font-medium text-gray-700">
                                {rowIndex + 1}
                            </td>
                            {columns.map(col => (
                                <td key={`${rowIndex}-${col.key}`} className="px-6 py-4">

                                    {col.type === 'status' ? (
                                        <ReportStatusBadge status={row[col.key]} />
                                    ) : (
                                        col.key == 'checkInTime' ? convertDateTimeTo12Hour(row[col?.new_key] ?? '') :
                                            row[col.key]
                                    )}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ReportTable;
